<div ng-controller="addRecipientController as ctrl" class="activity-details" c-toggle="ctrl.showActivity">
    <div class="activity-details solo">
        <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
    </div>
</div>